import ProductSubcategoryLinks from "./ProductSubcategoryLinks";

export default ProductSubcategoryLinks;
